// Copyright 2025-2026 - Hewlett Packard Enterprise Company
import React from 'react';
import { Box, Text } from 'grommet';
import PropTypes from 'prop-types';
import { User } from 'grommet-icons/icons/User';

const ChatQuery = ({ query }) => (
  <Box
    width={{ max: '100%' }}
    direction="column"
    margin={{ bottom: 'medium', left: 'xsmall' }}
  >
    <Box direction="row" justify="end" align="center" flex>
      {query !== undefined && (
        <>
          <Box
            data-testid="chat-user-query"
            direction="row"
            background="background-back"
            pad="small"
            round="small"
            fill
            margin={{ left: 'large' }}
            style={{
              paddingLeft: '10px',
              wordBreak: 'break-word',
            }}
          >
            <Text data-testid="chat-user-query-text">{query}</Text>
          </Box>
          <Box margin={{ left: 'small', right: 'small' }}>
            <User color="text-strong" />
          </Box>
        </>
      )}
    </Box>
  </Box>
);

export default ChatQuery;

ChatQuery.propTypes = {
  query: PropTypes.string.isRequired,
};
